import React, { ReactNode } from 'react';
import { createStyles } from 'app/utils/css';
import { ButtonA, ColorScheme as ButtonColorScheme, Size as ButtonSize } from './ButtonClassNameA';
import Spinner, {
  ColorScheme as SpinnerColorScheme,
  SpinnerSize,
} from 'app/components/common/Spinner';
import { ExtractProps } from '../../../utils/types';

const Styles = createStyles({
  loadingContainer: {
    position: 'relative',
    textAlign: 'center',
  },
  transparentChildren: {
    visibility: 'hidden',
  },
  spinner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

interface IContentProps extends ExtractProps<typeof ButtonA> {
  isLoading: boolean;
  children: ReactNode;
  spinnerColorScheme?: SpinnerColorScheme;
  spinnerSize?: SpinnerSize;
}

export const LoadingButtonContent: React.SFC<IContentProps> = ({
    isLoading,
    children,
    spinnerColorScheme = SpinnerColorScheme.Light,
    spinnerSize = SpinnerSize.Small,
}) => (
  <Styles>{(css) =>
    <div data-testid="loading-button-content" className={css('loadingContainer')}>
      <div className={isLoading ? css('transparentChildren') : undefined}>
        {children}
      </div>

      {isLoading &&
        <div data-testid="loading-button-spinner" className={css('spinner')}>
          <Spinner
            displayAsBlock
            size={spinnerSize}
            color={spinnerColorScheme}
          />
        </div>}
    </div>
  }</Styles>
);

interface IProps extends ExtractProps<typeof ButtonA> {
  isLoading: boolean;
}

const LoadingButtonA: React.SFC<IProps> = ({ isLoading, children, ...buttonProps }) => (
  <ButtonA {...buttonProps}>
    <LoadingButtonContent
      isLoading={isLoading}
      spinnerColorScheme={
        buttonProps.colorScheme === ButtonColorScheme.Secondary ?
          SpinnerColorScheme.Link :
          SpinnerColorScheme.Light
      }
      spinnerSize={
        buttonProps.size === ButtonSize.Tiny
        ? SpinnerSize.Tiny
        : SpinnerSize.Small
      }
    >
      {children}
    </LoadingButtonContent>
  </ButtonA>
);

export default LoadingButtonA;
